import React from "react";
import Reveal from "../common/Reveal";
import ProjectCard from "./ProjectCard";
import projects from "../data/projects";

export default function Projects({ onOpen }) {
  return (
    <section id="projects" className="section">
      <div className="section-inner">
        <Reveal className="section-label-row tight">
          <span className="section-label mono">04 / SELECTED WORK</span>
          <span className="section-line" />
          <span className="projects-count mono">
            {projects.length} projects
          </span>
        </Reveal>
        <Reveal as="h2" className="section-headline">
          Real products, shipped and running in the wild.
        </Reveal>

        <div className="projects-grid stagger">
          {projects.map((project) => (
            <Reveal as="div" key={project.id}>
              <ProjectCard project={project} onOpen={onOpen} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
